import {API} from "./API";
import type {RecommendationsProductsResponse} from "../@types/recommendation";
import {get} from "svelte/store";
import {storeID, uuid, cdnCacheKey} from "../store/store";

const BASE_URL = "https://api.instantsearchplus.com";

export const Products = {
    geProductByIds: () => {
        return API.get<RecommendationsProductsResponse>({
            url: `${BASE_URL}/full_text_search`,
            params: {
                UUID: get(uuid),
                store_id: get(storeID),
                cdn_cache_key: get(cdnCacheKey),
                q: "",
                facets_required: 0,
                page_num: 1,
                order: '-popularity_score',
            }
        });
    }
}